// @ts-strict-ignore
import { usePractitionerTypesQuery } from "@shared/data/queries/PractitionerTypesQuery/PractitionerTypes.query";
import { PractitionerSignUp } from "@unauthenticated/shared/components/PractitionerSignUp/PractitionerSignUp";
import type { PractitionerSignUpUnauthenticatedSharedMutation as PractitionerSignUpMutationData } from "@unauthenticated/shared/data/mutations/PractitionerSignUp.mutation.generated";

import { OAuthStep } from "../oauthStep";

interface Props {
  clientId: string;
  onUpdateCurrentStep: (step: OAuthStep) => void;
  setSsoErrorMessage: (error: string) => void;
  ssoErrors?: string;
}

const OAuthSignUpStep = ({
  clientId,
  onUpdateCurrentStep,
  ssoErrors,
  setSsoErrorMessage,
}: Props) => {
  const { data: practitionerTypesData } = usePractitionerTypesQuery();

  const handleOnCompleted = (data: PractitionerSignUpMutationData) => {
    if (data?.auth?.practitionerSignUp?.errors?.message) {
      // TODO: Show some errors in here
    } else {
      onUpdateCurrentStep(OAuthStep.CERTIFICATION);
    }
  };

  const onSignInRedirect = () => {
    setSsoErrorMessage(null);
    onUpdateCurrentStep(OAuthStep.SIGN_IN);
  };

  const additionalAttributes = {
    source: "oauth",
    signupSource: "oauth",
    apiClientId: clientId,
    redirectPath: window.location.href,
  };

  return (
    <PractitionerSignUp
      practitionerTypes={practitionerTypesData?.practitionerTypes ?? []}
      pageVersion="oauth_prac"
      onCompleted={handleOnCompleted}
      ssoErrors={ssoErrors}
      isOAuth
      additionalAttributes={additionalAttributes}
      onSignInRedirect={onSignInRedirect}
    />
  );
};

export { OAuthSignUpStep };
